import { GET_APPLICATION, LIST_APPLICATION } from "../actions/types";

const initialState = {
  application: null,
  applications: {
    count: 0,
    rows: [],
  },
};

const applications = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPLICATION:
      return {
        ...state,
        application: action.payload,
        applications: initialState.applications,
      };
    case LIST_APPLICATION:
      return {
        ...state,
        application: initialState.application,
        applications: action.payload,
      };
    default:
      return state;
  }
};

export default applications;
